// Require dependencies
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

// Check if a date has passed compared to 'today'
export const hasDatePassed = (dateToCheck) => {

	// Get current date
	const today = dayjs();

	// Return comparison
  	return dayjs(dateToCheck).isBefore(today, 'day');

}

// Check if 'today' falls between two dates
export const isTodayBetween = (startDate, endDate) => {

	// Get current date
	const today = dayjs();

	// Return comparison
	return today.isBetween(dayjs(startDate), dayjs(endDate), 'day', '[]');

};
